export const INFO_TYPE = 'info';
export const WARNING_TYPE = 'warning';
export const SUCCESS_TYPE = 'success';
export const ERROR_TYPE = 'error';

export type NotificationType =
  | typeof SUCCESS_TYPE
  | typeof INFO_TYPE
  | typeof WARNING_TYPE
  | typeof ERROR_TYPE;

export interface INotification {
  id: string;
  type: NotificationType;
  title: string;
  message: string;
}
